import React from "react";

export default function RMHeader({headertxt,closeFunction}){
    return(
        <div className="flex justify-between items-center">
            <p className="headingText">{headertxt}</p>
            <p
                className="text-base font-medium lg:text-lg lg:font-medium text-navLink lg:block cursor-pointer"
                onClick={()=>{closeFunction();}}
            >
                Discard
            </p>
        </div>
    )
}